import * as angular from "angular";
import {IController, IScope} from "angular";
import {$agentFactory} from "../../$agent.factory";
import {SplitService} from "../../../commons/services/split-service.service";
import {GpsPermissionType} from "../../types/gps-permission.type";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {AgentAuthType} from "../../types/agentAuth.type";
import {AgentStatusType} from "../../types/agentStatus.type";

export class AgentsTableRowCtrl implements IController {

  agentId: string;
  isSelected: any;
  expendedAgentId: any;
  columns: any;
  siteTimeZone: string;

  onAgentExpand: Function;
  onToggleSelected: Function;

  public isSmallScreen: boolean;
  public isAgentAssistantEnabled: any;
  public gpsPermissionType: typeof GpsPermissionType = GpsPermissionType;
  public filterAgentsByGpsEnabled: boolean;
  public agentAuthType: typeof AgentAuthType = AgentAuthType;
  public agentStatusType: typeof AgentStatusType = AgentStatusType;
  public agentTeamNames: string[];

  constructor(private $agent: $agentFactory, private $mdMedia, private $scope: IScope,
              private splitService: SplitService, private siteContextService: SiteContextService) {
    this.isAgentAssistantEnabled = this.splitService.getSiteAgentAssistantMode();
    this.filterAgentsByGpsEnabled = this.siteContextService.getSiteInfo().filterAgentsByGpsEnabled;
  }

  $onInit() {
    if (this.agentId) {
      this.$agent(this.agentId).$bindCtrlToId(this.$scope, this, 'agent', 'agentId')
        .then((res) => {
          this.agentTeamNames = res.teamReferences?.map(t => t.name) || [];
        });
    }
  }

  $onChanges(changes) {
    if (changes.agentId && !changes.agentId.isFirstChange()) {
      this.$onInit();
    }
  }

  $doCheck() {
    this.isSmallScreen = !this.$mdMedia('gt-md');
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsTableRow', {
    require: {
      agentsTableCtrl: '^agentsTable'
    },
    bindings: {
      agentId: '<',
      isSelected: '<?',
      columns: '<?',
      expendedAgentId: '<?',
      siteTimeZone: '<?',
      onAgentExpand: '&',
      onToggleSelected: '&'
    },
    template: require('./agents-table-row.html').default,
    controller: AgentsTableRowCtrl
  });
